import { Framework } from '@/framework/instance';
import { type ContextMenuPlugin } from '../context-menu/context-menu';
import { getCropImgState } from './states/crop-img-state';

export class CropImgPlugin extends Framework {
    private rootTarget: any;

    tryGetContextMenu() {
        const contextMenu = this.framework.getInstance<ContextMenuPlugin>('ContextMenuPlugin');
        if (!contextMenu) {
            console.error('ContextMenuPlugin is not found');
            return null;
        }
        return contextMenu;
    }

    /** 获取绘制配置 */
    getConfig() {}

    /** 打开绘制 */
    open() {
        const activeLayer = this.framework.operate.getActivePickLayer();
        if (!activeLayer) return;
        this.framework.stage.addOrUpdate({
            ...activeLayer,
            __isCropImage: true,
        });
        this.tryGetContextMenu()?.disableMenu();
        this.framework.operate.disablePick(false);
        this.framework.operate.setActiveLayer(activeLayer.id);

        getCropImgState(this.framework.identity).setIsCropImage(true);
    }

    /** 关闭绘制 */
    close() {
        this.tryGetContextMenu()?.enableMenu();
        this.framework.operate.enablePick();
        this.destroy();

        const activeLayer = this.framework.operate.getActivePickLayer();
        if (!activeLayer) return;
        if (!activeLayer.__isCropImage) return;
        this.framework.stage.addOrUpdate({
            ...activeLayer,
            __isCropImage: false,
        });
        this.framework.operate.setActiveLayer(activeLayer.id);
    }

    setIsAutoCutoutLayer(isAutoCutoutLayer: boolean) {
        getCropImgState(this.framework.identity).setIsAutoCutoutLayer(isAutoCutoutLayer);
    }

    destroy() {
        getCropImgState(this.framework.identity).setIsCropImage(false);
        getCropImgState(this.framework.identity).setIsAutoCutoutLayer(false);
        this.rootTarget = null;
    }

    checkIsOperateTarget(target: any) {
        return (this.rootTarget?.getElementsByClassName('base-operate')?.[0] as HTMLDivElement)?.contains(target);
    }

    setRootTarget(target: any) {
        this.rootTarget = target;
    }
}
